import React, { FC, ReactNode } from "react";

interface GradientButtonProps {
    children: ReactNode;
    onClick?: () => void;
    className?: string; // extra classes if needed
    icon?: ReactNode; // optional icon
}

const GradientFillButton: FC<GradientButtonProps> = ({ children, onClick, className, icon }) => {
    return (
        <button
            type="button"
            onClick={onClick}
            className={`flex items-center justify-center gap-2 px-4 py-2 rounded-xl font-semibold text-white bg-gradient-to-r from-primary to-secondary  ${className}`}
        >
            {icon && <span className="flex items-center">{icon}</span>}
            {children}
        </button>
    );
};

export default GradientFillButton;
